import {
  AccountIcon,
  DashboardIcon,
  DollarSquareIcon,
  MyWalletMenuIcon,
  PeopleIcon,
  TagUserIcon,
  UserIcon,
} from '@/assets';
import {
  ACCOUNT_ROUTE,
  COMMISSION_CLAIM_ROUTE,
  DASHBOARD_ROUTER,
  MY_WALLET_ROUTE,
  REFERRED_USER_LIST_ROUTE,
  SUB_AFFILIATE_LIST_ROUTE,
  SUB_AFFILIATE_ORGANIZATION_CHART_ROUTE,
} from '@/routes/constants';

export const menuSidebar = [
  {
    id: 1,
    is_group: true,
    title: 'Referrals',
    items: [
      {
        id: 1,
        title: 'Dashboard',
        path: DASHBOARD_ROUTER,
        icon: DashboardIcon,
      },

      {
        id: 2,
        title: 'Referred user list',
        path: REFERRED_USER_LIST_ROUTE,
        icon: UserIcon,
      },
    ],
  },
  {
    id: 2,
    is_group: true,
    title: 'Sub-affiliate accounts',
    items: [
      {
        id: 1,
        title: 'Sub-affiliate list',
        path: SUB_AFFILIATE_LIST_ROUTE,
        icon: TagUserIcon,
      },
      {
        id: 2,
        title: 'Organization chart',
        path: SUB_AFFILIATE_ORGANIZATION_CHART_ROUTE,
        icon: PeopleIcon,
      },
    ],
  },
  {
    id: 3,
    is_group: true,
    title: 'Commission',
    items: [
      {
        id: 1,
        title: 'Commission claim',
        path: COMMISSION_CLAIM_ROUTE,
        icon: DollarSquareIcon,
      },
    ],
  },
  {
    id: 4,
    is_group: true,
    title: 'Settings',
    items: [
      {
        id: 1,
        title: 'Account',
        path: ACCOUNT_ROUTE,
        icon: AccountIcon,
      },
      {
        id: 2,
        title: 'My wallet',
        path: MY_WALLET_ROUTE,
        icon: MyWalletMenuIcon,
      },
    ],
  },
];
